import script from "./insured-details.vue?vue&type=script&setup=true&lang=js"
export * from "./insured-details.vue?vue&type=script&setup=true&lang=js"

import "./insured-details.vue?vue&type=style&index=0&id=319d7bc3&lang=css"

const __exports__ = script;

export default __exports__